import { Injectable, EventEmitter, Output, HostListener } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
// import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { catchError, retry } from 'rxjs/operators';
import { throwError } from 'rxjs/';
import 'rxjs/add/operator/finally';
import { Login, UserInfo } from '../models/index';
import { LoaderService } from './loader.service';
import { environment } from '../../environments/environment';

@Injectable()

export class AuthService {
apiConnection = environment.apiConnection;

  constructor(private http: HttpClient, private loader: LoaderService) {}
  // http://localhost:11413
  @Output() authChange: EventEmitter<null> = new EventEmitter();


  private onSuccess(res: Response): void {
    console.log('Request successful');
  }



  createStripeCustomer(usr: UserInfo) {
    this.loader.startLoading();

    return this.http
      .post<UserInfo>(this.apiConnection + '/restricted/0/' + usr.rgID, usr)
      .pipe(catchError(this.handleError))
      .finally(() => this.loader.stopLoading());
  }



  startSubscription(usr: UserInfo) {
    this.loader.startLoading();
    return this.http
      .post<UserInfo>(this.apiConnection + '/restricted/5/' + usr.rgID, usr)
      .pipe(catchError(this.handleError))
      .finally(() => this.loader.stopLoading());
  }

  saveCustomer(usr: UserInfo) {
    this.loader.startLoading();

    return this.http
      .post<UserInfo>(this.apiConnection + '/restricted/1/' + usr.rgID, usr)
      .pipe(catchError(this.handleError))
      .finally(() => this.loader.stopLoading());
  }

  updateSubscription(usr: UserInfo) {
    this.loader.startLoading();

    return this.http
      .post<UserInfo>(this.apiConnection + '/restricted/2/' + usr.rgID, usr)
      .pipe(catchError(this.handleError))
      .finally(() => this.loader.stopLoading());
  }

  restartSubscription(usr: UserInfo) {
    this.loader.startLoading();
    return this.http
      .post<UserInfo>(this.apiConnection + '/restricted/3/' + usr.rgID, usr)
      .pipe(catchError(this.handleError))
      .finally(() => this.loader.stopLoading());
  }

  createStripeAccount(userID: string) {
    this.loader.startLoading();

    return this.http.post<any>(this.apiConnection + '/restricted/' + userID, null)
    .finally(() => this.loader.stopLoading());
  }



  login(_login: Login) {
    this.loader.startLoading();

    return this.http
      .post<Login>(this.apiConnection + '/authentication', _login)
      .pipe(catchError(this.handleError))
      .finally(() => this.loader.stopLoading());
  }


  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    console.log('logout');
    this.authChange.emit();
  }
  updateCard(usr: UserInfo) {
    this.loader.startLoading();
    return this.http
      .post<UserInfo>(this.apiConnection + '/restricted/4/' + usr.rgID, usr)
      .pipe(catchError(this.handleError))
      .finally(() => this.loader.stopLoading());
  }
  createAccount(_login: Login) {
    this.loader.startLoading();
    return this.http
      .post<UserInfo>(this.apiConnection + '/authentication/1/', _login)
      .pipe(catchError(this.handleError))
      .finally(() => this.loader.stopLoading());
  }

  resetPassword(_login: Login) {
    this.loader.startLoading();
    return this.http
      .put(this.apiConnection + '/authentication', _login)
      .pipe(catchError(this.handleError))
      .finally(() => this.loader.stopLoading());
  }

  getUserInfo() {
    this.loader.startLoading();
    console.log('getuserinfo called');
    const currUser = localStorage.getItem('currentUser');

    if (JSON.parse(currUser)) {
      return this.http.get<UserInfo>(
        this.apiConnection + '/restricted/0/' +
        JSON.parse(localStorage.getItem('currentUser')).userId
      ).pipe(catchError(this.handleError))
        .finally(() => this.loader.stopLoading());
    } else {
      return this.http.get<UserInfo>(
        this.apiConnection + '/restricted/0/' + '-1'
      ).pipe(catchError(this.handleError))
        .finally(() => this.loader.stopLoading());
    }
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(error.error);
  }
}
